export const HYBRID_APP_CHANGE_THEME = 'HYBRID_APP_CHANGE_THEME';

// Peripherals / Gestures
export const PENCIL_DOUBLE_TAP = 'PENCIL_DOUBLE_TAP';
export const TWO_FINGER_TAP = 'TWO_FINGER_TAP';
export const HYBRID_APP_FAKE_CONTEXT_MENU_EVENT_DETAIL = 999;

// Synthetic events
export const HYBRID_APP_CUSTOM_DOM_EVENTS = {
    PENCIL_DOUBLE_TAP: 'pencildbltap',
};

export const PENCIL_DOUBLE_TAP_PREFERRED_ACTIONS = {
    ignore: 'ignore',
    switchEraser: 'switchEraser',
    switchPrevious: 'switchPrevious',
    showColorPalette: 'showColorPalette',
    showInkAttribute: 'showInkAttributes',
};
